import { HStack, Box, Text } from '@chakra-ui/react';
import { CalloutBlockViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';
import { DocumentBlockItemViewProps } from '../item/documentItemView';

export function createDocumentCalloutView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<DocumentBlockItemViewProps>;
    }
): React.FC<CalloutBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        return (
            <BlockItem as={<HStack align="center" />} {...props.block}>
                <HStack
                    px={6}
                    py={4}
                    bg="whiteAlpha.50"
                    borderWidth={1}
                    borderColor="whiteAlpha.200"
                    borderRadius="lg"
                    w="full"
                    color="whiteAlpha.800"
                    spacing={3}
                    align="start"
                >
                    {props.icon ? (
                        <Box
                            position="relative"
                            top={-0.2}
                            fontSize="2xl"
                            width="1em"
                            height="1em"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="md"
                            cursor="pointer"
                            _hover={{ bg: 'whiteAlpha.50' }}
                        >
                            <Text lineHeight={1}>{props.icon.text}</Text>
                        </Box>
                    ) : null}
                    {props.children}
                </HStack>
            </BlockItem>
        );
    };
}
